import * as searchKeySelectors from './search-key/search-key.selectors'
import * as customerSelectors from './customer/customer.selectors'
import { sharedSelectors, userSelectors } from 'shared-lib'

export const selectors = { ...sharedSelectors, ...userSelectors, ...searchKeySelectors, ...customerSelectors }
